import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, Polyline, Polygon } from 'react-leaflet';
import {Row, Col} from 'reactstrap';
import "assets/css/map.css";
import L from 'leaflet'
import { api_GET_External } from "api/axios";
import { formateDateandTimeFromJson } from "helpers/formats";

export default function MapaLeafletRota({ item }) {

    useEffect(() => {
        handleLoadRastreamento();
    }, [item]);

    const [centerMap, setCenterMap] = React.useState([-23.547241, -46.637407])
    const [zoomMap, setzoomMap] = React.useState(14)
    const ChangeMap = ({ center, zoom }) => {
        const mapInstance = useMap();
        mapInstance.setView(center, zoom);
        return null;
    }

    const [start, setStart] = React.useState(null);
    const [stop, setStop] = React.useState(null);
    const [lineRastreio, setLineRastreio] = React.useState(null);
    const [cercaRastreio, setCercaRastreio] = React.useState(null);
    const [mensagemErro, setMensagemErro] = React.useState(null);
    const [dadosRastreio, setDadosRastreio] = React.useState(null);

    const handleLoadRastreamento = () => {
        api_GET_External(item.urlDetailMarker, item.header).then(result => {
            if (result.status !== 200) {
                setMensagemErro(JSON.stringify(result.message));
                return;
            }

            if (!result.data.sucesso) {
                setMensagemErro(result.data.mensagemErro);
                return;
            }

            setDadosRastreio(result.data);
            let polyline = [];
            if (result.data.retorno && result.data.retorno.rotaRealizada && result.data.retorno.rotaRealizada.length > 0) {
                for (var i = 0; i < result.data.retorno.rotaRealizada.length; i++) {
                    polyline.push([result.data.retorno.rotaRealizada[i].lat, result.data.retorno.rotaRealizada[i].lng])
                }
                if (polyline.length > 1) {
                    setStart(polyline[0]);
                    setStop(polyline[polyline.length - 1]);
                }
                setLineRastreio(polyline);
            }
            else {
                setMensagemErro("Nenhum registro retornado para rastreio");
            }

            if (result.data.retorno && result.data.retorno.cercasSetores && result.data.retorno.cercasSetores.length > 0) {
                let multipoligon = [];
                for (var s in result.data.retorno.cercasSetores) {
                    let poligon = [];
                    for (var i = 0; i < result.data.retorno.cercasSetores[s].poligonoCerca.length; i++) {
                        poligon.push([result.data.retorno.cercasSetores[s].poligonoCerca[i].lat, result.data.retorno.cercasSetores[s].poligonoCerca[i].lng])
                    }
                    multipoligon.push(poligon);
                }

                if (multipoligon.length > 0)
                    setCenterMap(multipoligon[0][0]);

                setCercaRastreio(multipoligon);
            }
            else if (polyline.length > 0) {
                setCenterMap(polyline[polyline.length - 1]);
                setzoomMap(12);
            }
        });
    }

    return (
        <>
            {dadosRastreio &&
                <div>
                    <Row>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Prefixo: </strong>{dadosRastreio.retorno.prefixo}</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Placa: </strong>{dadosRastreio.retorno.placa}</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Tipo de Operação: </strong>{dadosRastreio.retorno.tipoOperacao}</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>ÚLtima Atualização: </strong>{formateDateandTimeFromJson(dadosRastreio.retorno.dataAtualizacaoLocalizacao)}</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Status: </strong>{dadosRastreio.retorno.status}</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Turno: </strong>{dadosRastreio.retorno.turno}</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Realizado: </strong>{dadosRastreio.retorno.percRealizado}%</label>
                        </Col>
                        <Col lg="6" md="6" sm="12">
                            <label><strong>Percorrido: </strong>{dadosRastreio.retorno.kmPercorrida} km</label>
                        </Col>                        
                    </Row>
                </div>
            }
            <div id="map">
                <div className="useloading">
                    <MapContainer style={{ zIndex: "0", height: "60vh" }}>
                        <ChangeMap center={centerMap} zoom={zoomMap}></ChangeMap>
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        />
                        {start && <Marker position={start} icon={new L.Icon({ iconUrl: require('assets/img/icons/play.png'), iconRetinaUrl: require('assets/img/icons/play.png') })}></Marker>}
                        {stop && <Marker position={stop} icon={new L.Icon({ iconUrl: require('assets/img/icons/truck.png'), iconRetinaUrl: require('assets/img/icons/truck.png') })}></Marker>}
                        {lineRastreio && lineRastreio.length > 0 && <Polyline positions={lineRastreio} pathOptions={{ color: 'red' }} />}
                        {cercaRastreio && cercaRastreio.length > 0 && <Polygon positions={cercaRastreio} pathOptions={{ fillColor: 'blue' }} />}
                    </MapContainer>
                </div>
            </div>
            <div className="mt-2">
                {mensagemErro && <strong className="text-danger">Atenção: {mensagemErro}</strong>}
            </div>
        </>
    )
}